/**
 * Shared framer-motion configuration objects.
 * Defined once at module scope so components do not allocate new prop objects on every render.
 */
export const VIEWPORT_ONCE = { once: true };
export const VIEWPORT_ONCE_PARTIAL = { once: true, amount: 0.3 };

export const SCALE_IN_INITIAL = { opacity: 0, scale: 0.95 };
export const SCALE_IN_ANIMATE = { opacity: 1, scale: 1 };
export const SCALE_IN_TRANSITION = { duration: 0.5, delay: 0.2 };
export const SCALE_IN_TRANSITION_SLOW = { duration: 0.6, delay: 0.2 };

export const FADE_UP_INITIAL = { opacity: 0, y: 10 };
export const FADE_UP_ANIMATE = { opacity: 1, y: 0 };
/** Staggered entrance transition for list items (index-based delay). */
export const fadeUpTransition = (index, step = 0.1, duration = 0.4) => ({ duration, delay: index * step });
